import { useEffect, useState } from 'react';
import {
  getFonemaCallBusySnapshot,
  subscribeFonemaCallBusy
} from '../../../services/fonemaCallBusyService';

/**
 * Subscribes to Fonema session busy state (incoming ringing, active call, or outbound initiate UI).
 * Sources: useFonemaWhatsappAudio (incoming) + FonemaCallManager (active / initiate).
 */
export default function useFonemaCallBusy() {
  const [busy, setBusy] = useState(getFonemaCallBusySnapshot);

  useEffect(() => {
    const unsubscribe = subscribeFonemaCallBusy(setBusy);
    return unsubscribe;
  }, []);

  return busy;
}
